import { Route } from 'react-router';
import { Home } from './Home';
import { Inbox } from './Inbox';
import { Join } from './Join';
import { JoinAnother } from './JoinAnother';
import { Scan } from './Scan';

/** Launcher routes (member side). Owned by the launcher agent. `/join/scan` outranks `/join/:inviteCode` (static segment). */
export const launcherRoutes = (
  <>
    <Route path="/" element={<Home />} />
    <Route path="/join" element={<JoinAnother />} />
    <Route path="/join/scan" element={<Scan />} />
    <Route path="/join/:inviteCode" element={<Join />} />
    <Route path="/inbox" element={<Inbox />} />
  </>
);
